module.exports = __webpack_public_path__ + "static/media/Varghese.3b3b5e05.jpg";